import type { ReactNode } from 'react';

/** Shared page header for 生词本 / 复习 / 资料库 / 我的: English eyebrow, bold title, one-line subtitle. */
export function PageHead({ eyebrow, title, sub, children }: { eyebrow: string; title: string; sub?: string; children?: ReactNode }) {
  return (
    <header className="page-intro">
      <div className="eyebrow">{eyebrow}</div>
      <h1>{title}</h1>
      {sub && <p className="muted">{sub}</p>}
      {children}
    </header>
  );
}
